/// <reference path="../../_ext/Bases/GridBase.ts" />
namespace TabAurous.Purchase {

    @Serenity.Decorators.registerClass()
    export class PurchaseMasterGrid extends _Ext.GridBase<PurchaseMasterRow, any> {
        protected getColumnsKey() { return 'Purchase.PurchaseMaster'; }
        protected getDialogType() { return PurchaseMasterDialog; }
        protected getIdProperty() { return PurchaseMasterRow.idProperty; }
        protected getInsertPermission() { return PurchaseMasterRow.insertPermission; }
        protected getLocalTextPrefix() { return PurchaseMasterRow.localTextPrefix; }
        protected getService() { return PurchaseMasterService.baseUrl; }
        protected get_ExtGridOptions() { return Q.deepClone(q.DefaultMainGridOptions) }

        rowSelection: Serenity.GridRowSelectionMixin;
        private autoSize;
        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.addDateRangeFilter("TransDate", "Date");
        }

        protected addButtonClick() {

            Q.reloadLookup(OMS.VoucherMasterRow.lookupKey);
            let now = new Date();
            var voucherNo = FormatHelper.GetVoucherNo(13);
            var userDefinition = Q.Authorization.userDefinition;

            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[13].AutoPosting;
            this.editItem(<PurchaseMasterRow>{
                VoucherNo: voucherNo,
                Line_No: 0,
                CompanyId:  userDefinition.CompanyId,
                FinancialYearId:  userDefinition.FinancialYearId,
                UserId:  userDefinition.UserId,
                CurrencyId:  userDefinition.CurrencyId,
                VoucherTypeId: 13,
                TransDate: now.toDateString(),
                RoundOff: 0,
                EmployeeId: userDefinition.UserId,
                AdditionalCharges: 0,
                AutoPosting: autoposting
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        }
        protected createToolbarExtensions() {
            super.createToolbarExtensions();
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }
        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: "VendorLKUP",
                    multiple: true

                },
                field: 'PartyId',
                title: 'Party',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).VendorIds = temp;
                    }
                },

                cssClass: 'hidden-xs'
            });


            return filters;
        }

        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            var addbutton = buttons.filter(x => x.cssClass == "add-button")[0];
            addbutton.hotkey = 'alt+n';
            addbutton.hint = 'alt+n';

            buttons.push({
                title: 'Import Sales',
                cssClass: 'import-xlsx-button',
                onClick: () => {
                    if (!this.onViewSubmit()) {
                        return;
                    }

                    let transids;
                    PurchaseMasterService.PostedTransIdList({}, response => { transids = response.Entities }, { async: false });
                    var _transids = transids.map(x => x.RefTransId);
                    var dialog = new Common.VoucherPostingDialog();
                    dialog.transids = _transids;
                    dialog.vouchertypeid = 19;
                    dialog.element.height(500);
                    dialog.element.width(500);
                    dialog.dialogOpen();
                    dialog.element.on('dialogclose', () => {
                        //this.refresh();

                         
                        if (dialog.checksuccess) {
                            var partyid = parseInt(dialog.form.PartyId.value);
                            if (dialog.vouchernos.length > 0)
                                PurchaseMasterService.APIImportSales({ Entities: dialog.vouchernos ,PartyId:partyid}, response => { this.refresh() }, { async: false });
                        }
                    });

                    //var pickerDialog = new _Ext.GridItemPickerDialog({
                    //    gridType: grid, multiple: true
                    //});
                    ////pickerDialog.onSuccess = (selectedItems: POSOrderRow[]) => {
                    ////    let selectedItems2 = selectedItems;
                    ////    for (var i = 0; i < selectedItems2.length; i++) {
                    ////        var order = selectedItems2[i];
                    ////        order.TransId = null;
                    ////        order.NetAmount = order.NetAmount == undefined ? 0 : order.NetAmount;
                    ////        order.GrossAmount = order.GrossAmount == undefined ? 0 : order.GrossAmount;
                    ////        order.ItemDetails = ItemGridHelper.SetSalesOrderGrid(order.ItemDetails, new Date(order.TransDate), 0, 1, 0, 0, 0);

                    ////        POSOrderService.Create({ Entity: order }, () => { }, { async: false });

                    ////        this.refresh();
                    ////    }

                    ////}
                    //pickerDialog.dialogOpen();
                }
            });
            return buttons;
        }

        protected createToolbar(buttons: Serenity.ToolButton[]): void {
            var toolbarDiv = $('<div class="grid-toolbar"></div>').appendTo(this.element);
            this.toolbar = new Serenity.Toolbar(toolbarDiv, { buttons: buttons, hotkeyContext: document.getElementsByTagName('body')[0] });
        }




    }
}